module.exports = __webpack_public_path__ + "img/UsersGroupRounded.edd334f1.svg";